import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Tag, Text, Tooltip } from '@chakra-ui/react';
import { useIntl } from 'react-intl';
export default function AliasResponse(param) {
    var response = param.response, alias = param.alias;
    var intl = useIntl();
    if (alias == null || alias.length === 0) {
        return /*#__PURE__*/ _jsx(Text, {
            whiteSpace: "normal",
            children: response
        });
    }
    return /*#__PURE__*/ _jsxs(Text, {
        whiteSpace: "normal",
        children: [
            /*#__PURE__*/ _jsx(Tooltip, {
                display: "inline-flex",
                placement: "top",
                label: intl.formatMessage({
                    id: "0Oso9n",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Will trigger command "
                        },
                        {
                            type: 1,
                            value: "alias"
                        },
                        {
                            type: 0,
                            value: " instead."
                        }
                    ]
                }, {
                    alias: alias
                }),
                children: /*#__PURE__*/ _jsx(Tag, {
                    children: alias
                })
            }),
            ' ',
            response
        ]
    });
}
